import * as THREE from 'three';

/**
 * First-person perspective camera (transform driven by Player).
 */
export class CameraSystem {
  /**
   * @param {{
   *   aspect: number;
   *   config: import('../config.js').CONFIG['camera'];
   * }} options
   */
  constructor({ aspect, config }) {
    this.threeCamera = new THREE.PerspectiveCamera(
      config.fov,
      aspect,
      config.near,
      config.far,
    );
    this.threeCamera.rotation.order = 'YXZ';
  }

  setAspect(aspect) {
    this.threeCamera.aspect = aspect;
    this.threeCamera.updateProjectionMatrix();
  }
}
